module.exports = __webpack_public_path__ + "img/que_logo.97f36ae0.jpg";